import script from "./TableModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TableModal.vue?vue&type=script&setup=true&lang=js"

import "./TableModal.vue?vue&type=style&index=0&id=1299932c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1299932c"]])

export default __exports__